import { ArrowDown, RightCheck, Warning } from '@core/ui';
import { forwardRef, PropsWithChildren, PropsWithRef } from 'react';
import { LabelHeading } from '../..';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    hasIssues: boolean;
}

export const BroadcastStatusToggle = forwardRef<PropsWithRef<HTMLButtonElement>, PropsWithChildren<Props>>(({ hasIssues, ...props }: Props, ref) => (
    <button
        ref={ref}
        className="hover:bg-gray-200 focus-within:bg-gray-200 rounded-md flex flex-col justify-center py-1 px-2 md:px-3 lg:px-4 transition-colors ease-in-out duration-200"
        aria-controls="statusPanel"
        {...props}
    >
        <LabelHeading name="Status" />
        <div className="flex items-center justify-between gap-2">
            {hasIssues ? <Warning classNames="size-6 motion-safe:animate-bounceWarning" /> : <RightCheck classNames="size-5 fill-success me-1" />}
            <ArrowDown classNames="h-2.5 fill-primary" />
        </div>
    </button>
));
